import type { RecoilState } from "recoil"
import { useRecoilState } from "recoil"

import type { IToggleSwitchBoard } from "./types"

export type UseToggleState = (
  toggleAtom: RecoilState<boolean>,
) => IToggleSwitchBoard

export const useToggleState: UseToggleState = (toggleAtom) => {
  const [state, setState] = useRecoilState<boolean>(toggleAtom)

  return {
    state,
    on: () => setState(true),
    off: () => setState(false),
    toggle: () => setState(!state),
  }
}
